module.exports = __webpack_public_path__ + "img/yyclq-icon.3364dbdc.png";